var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 181.2,
    height: 38.939,
    viewBox: "0 0 181.2 38.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 181.199,
    height: 38.939,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M6.421,8.679.02,15.087,0,15.1V27.643L6.29,21.357,19.346,34.415H32.159L12.7,14.951,18.015,9.63l-6.27-6.272Z",
    transform: "translate(0 4.334)",
    fill: "#f57d20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M2.746,0,22.212,19.468,19.02,22.66l-2.126,2.126,6.272,6.272L34.9,19.319V6.772l-6.286,6.291L15.557,0Z",
    transform: "translate(3.545 0.001)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M37.606,2.645V6.257H32.353V21.375H28.435V6.257H23.127V2.645Z",
    transform: "translate(29.855 3.414)",
    fill: "#f57d20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M41.989,11.549a7.677,7.677,0,0,1-.112,1.473H33.266q.357,2.8,2.722,2.8a2.107,2.107,0,0,0,2.224-1.443h3.471a5.906,5.906,0,0,1-2.025,3.308,5.9,5.9,0,0,1-3.782,1.194,5.915,5.915,0,0,1-4.6-1.876,7.275,7.275,0,0,1-1.709-5.1A7.494,7.494,0,0,1,31.3,6.7a5.984,5.984,0,0,1,4.683-1.931,5.516,5.516,0,0,1,4.405,1.849,7.277,7.277,0,0,1,1.6,4.932M35.9,7.742q-2.2,0-2.614,2.7h5.031a3.2,3.2,0,0,0-.667-1.975,2.168,2.168,0,0,0-1.75-.722",
    transform: "translate(38.169 6.156)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M41.4,18.885a6.246,6.246,0,0,1-4.114-1.21,4.634,4.634,0,0,1-1.583-3.432h3.5q.082,1.639,2.167,1.638a2.724,2.724,0,0,0,1.489-.346,1.037,1.037,0,0,0,.541-.9,1.09,1.09,0,0,0-.749-.971,8.241,8.241,0,0,0-1.821-.6q-1.072-.237-2.14-.584a4.031,4.031,0,0,1-1.821-1.21,3.261,3.261,0,0,1-.749-2.222,3.833,3.833,0,0,1,1.4-3.127,5.8,5.8,0,0,1,3.791-1.152A5.752,5.752,0,0,1,45.1,5.92,4.234,4.234,0,0,1,46.6,9.1H43.126a1.612,1.612,0,0,0-1.808-1.416,2.053,2.053,0,0,0-1.207.307.948.948,0,0,0-.433.806,1.068,1.068,0,0,0,.751.958,8.531,8.531,0,0,0,1.819.57,19.485,19.485,0,0,1,2.142.57,3.889,3.889,0,0,1,1.821,1.251,3.514,3.514,0,0,1,.749,2.318A3.9,3.9,0,0,1,45.472,17.7,6.362,6.362,0,0,1,41.4,18.885",
    transform: "translate(46.093 6.156)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M49.491,10.524H46.712V17a1.293,1.293,0,0,0,.334,1.017,1.85,1.85,0,0,0,1.194.289h.974v2.614a8.02,8.02,0,0,1-2.2.334,3.708,3.708,0,0,1-2.765-1,4.034,4.034,0,0,1-.987-2.946V10.524H41.152v-3h2.112v-4.7h3.448v4.7h2.779Z",
    transform: "translate(53.123 3.65)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M57.363,2.645h4.279l-6.309,11.17v7.56H51.416v-7.56L45.107,2.645h4.282l3.972,7.613Z",
    transform: "translate(58.229 3.415)",
    fill: "#f57d20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M64.832,15.744h.639V18.5a4.866,4.866,0,0,1-1.53.25,2.979,2.979,0,0,1-2.694-1.278,5.346,5.346,0,0,1-3.78,1.418,4.775,4.775,0,0,1-3.972-1.89,8.1,8.1,0,0,1-1.473-5.113,8.051,8.051,0,0,1,1.542-5.2,4.906,4.906,0,0,1,4.016-1.917,4.161,4.161,0,0,1,3.194,1.306l.085-1.056h3.308v9.67a1.613,1.613,0,0,0,.151.82.565.565,0,0,0,.515.236m-6.7-.027q2.557,0,2.557-3.947,0-3.835-2.5-3.833-2.557,0-2.557,3.915,0,3.866,2.5,3.865",
    transform: "translate(67.154 6.156)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M65.921,4.768a4.072,4.072,0,0,1,3.333,1.377,6.142,6.142,0,0,1,1.139,4.014v8.476H66.81V10.408q0-2.474-1.917-2.472a2.087,2.087,0,0,0-1.805.889,4.428,4.428,0,0,0-.641,2.612v7.2H58.863V5.018h3.416l.057,1.029a5.082,5.082,0,0,1,3.585-1.278",
    transform: "translate(75.987 6.156)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M73.059,10.524H70.28V17a1.293,1.293,0,0,0,.334,1.017,1.85,1.85,0,0,0,1.194.289h.974v2.614a8.02,8.02,0,0,1-2.2.334,3.708,3.708,0,0,1-2.765-1,4.034,4.034,0,0,1-.987-2.946V10.524H64.72v-3h2.112v-4.7H70.28v4.7h2.779Z",
    transform: "translate(83.547 3.65)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M76.167,4.768a2.562,2.562,0,0,1,1.084.195V8.186H75.808Q73,8.186,73,12.161v6.474H69.416V5.018h3.416l.112,1.668a4.371,4.371,0,0,1,1.432-1.391,3.44,3.44,0,0,1,1.791-.527",
    transform: "translate(89.609 6.156)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M86.035,15.744h.639V18.5a4.866,4.866,0,0,1-1.53.25,2.979,2.979,0,0,1-2.694-1.278,5.346,5.346,0,0,1-3.78,1.418,4.775,4.775,0,0,1-3.972-1.89,8.1,8.1,0,0,1-1.473-5.113,8.051,8.051,0,0,1,1.542-5.2,4.906,4.906,0,0,1,4.016-1.917,4.161,4.161,0,0,1,3.194,1.306l.085-1.056h3.308v9.67a1.613,1.613,0,0,0,.151.82.565.565,0,0,0,.515.236m-6.7-.027q2.557,0,2.557-3.947,0-3.835-2.5-3.833-2.557,0-2.557,3.915,0,3.866,2.5,3.865",
    transform: "translate(94.525 6.156)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M28.239,16.951h3.913V18.53a3.248,3.248,0,0,1-.857,2.323,3.324,3.324,0,0,1-2.545.914,3.249,3.249,0,0,1-2.669-1.139,4.763,4.763,0,0,1-.932-3.106,4.659,4.659,0,0,1,.948-3.088A3.3,3.3,0,0,1,28.773,13.3a3.332,3.332,0,0,1,2.275.779,3.081,3.081,0,0,1,1.045,1.959H30.354a1.309,1.309,0,0,0-.518-.893,1.72,1.72,0,0,0-1.063-.323,1.612,1.612,0,0,0-1.416.694,3.5,3.5,0,0,0-.481,2q0,2.725,1.874,2.722a1.754,1.754,0,0,0,1.255-.405,1.294,1.294,0,0,0,.433-.978v-.415h-2.2Z",
    transform: "translate(32.465 17.172)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M33.133,19.976H36.61v1.578H31.417V13.36h1.716Z",
    transform: "translate(40.556 17.247)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M40.105,21.765a3.18,3.18,0,0,1-2.637-1.155,4.809,4.809,0,0,1-.926-3.09,4.625,4.625,0,0,1,.955-3.093A3.272,3.272,0,0,1,40.131,13.3a3.176,3.176,0,0,1,2.662,1.18,4.785,4.785,0,0,1,.923,3.051,4.741,4.741,0,0,1-.935,3.056,3.218,3.218,0,0,1-2.676,1.175m.014-1.533a1.574,1.574,0,0,0,1.4-.706,3.58,3.58,0,0,0,.474-2.007,3.593,3.593,0,0,0-.463-1.975,1.552,1.552,0,0,0-1.4-.71,1.585,1.585,0,0,0-1.379.68,3.5,3.5,0,0,0-.481,2.018,3.6,3.6,0,0,0,.467,2,1.56,1.56,0,0,0,1.381.694",
    transform: "translate(47.174 17.172)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M48.137,17.3a2.23,2.23,0,0,1,.836.765,2.239,2.239,0,0,1-.449,2.838,2.984,2.984,0,0,1-2,.651H42.847V13.361H46.4a2.918,2.918,0,0,1,1.938.6,2,2,0,0,1,.712,1.615,1.9,1.9,0,0,1-.912,1.727m-.79-1.558a.8.8,0,0,0-.261-.63,1.047,1.047,0,0,0-.722-.231h-1.8v1.739h1.869a.909.909,0,0,0,.662-.245.839.839,0,0,0,.25-.632m-.777,4.293a.99.99,0,0,0,.722-.268.915.915,0,0,0,.275-.694.887.887,0,0,0-.312-.715,1.192,1.192,0,0,0-.82-.27H44.565v1.947Z",
    transform: "translate(55.311 17.248)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M54.465,21.556,53.8,19.718h-2.9l-.669,1.837H48.447l3.113-8.195h1.567l3.113,8.195ZM51.45,18.188h1.8l-.9-2.493Z",
    transform: "translate(62.54 17.248)",
    fill: "#162d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M56.5,19.976h3.478v1.578H54.783V13.36H56.5Z",
    transform: "translate(70.72 17.247)",
    fill: "#162d52"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17565700c52c996d0dbdb0d7303ec13e.svg";
export { ForwardRef as ReactComponent };